export class OTAAirScheduleResponse {
  public destinationOptionList: OriginDestinationOption[] = [];


  getDestinationOptionList(): OriginDestinationOption[] {
    if (!this.destinationOptionList) {
      this.destinationOptionList = [];
    }
    return this.destinationOptionList;
  }
}

export class OriginDestinationOption {
  constructor(public flightSegments: FlightSegmentSch[] = []) {}
}

export class FlightSegmentSch {
  operator: string;
  arrivalDateTime: string;
  departureDateTime: string;
  flightNumber: string;
  destinationLocationCode: string;
  originLocationCode: string;
  /** undefined = aún no consultado (placeholder), null = fallo VIL (muestra "—"), number = éxito */
  availableSeats?: number | null;
  originCityName: string;
  destinationCityName: string;
  duration: string;
  blocked: boolean;

  constructor(data?: Partial<FlightSegmentSch>) {
    if (data) Object.assign(this, data);
  }

  get arrivalDayDiffDepartureDay(): boolean {
    return new Date(this.arrivalDateTime).getDate() !== new Date(this.departureDateTime).getDate();
  }
}
